module.exports = __webpack_public_path__ + "img/bw.6e0028ef.svg";